import { useState } from "react";
import { saveErrorReport } from "../services/reportError";
import { reactGaEvent } from "sdk/actions";

export default function useFeedbackModel() {
    const [isFeedbackModelOpen, setIsFeedbackModelOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [title, setTitle] = useState('');
    const [questionId, setQuestionId] = useState('');

    function openFeedbackModel(errorData) {
        setIsFeedbackModelOpen(true);
        setMessage(errorData.message);
        setQuestionId(errorData.questionId);
        setTitle(errorData.title);
    }

    async function reportErrorFn(errorMsg) {
        const errorObj = {
            questionId,
            title,
            message: `${message} : ${errorMsg}`
        };

        try {
            await saveErrorReport(errorObj);

            reactGaEvent("Report", "Submit Error");
            closeFeedBackModel();
        } catch (error) {
            console.error("Error while reporting issue:", error);

            // Optional: send analytics for failure
            reactGaEvent("Report", "Submit Error Failed");
        }
    }

    function closeFeedBackModel() {
        setIsFeedbackModelOpen(false);
    }

    return {
        isFeedbackModelOpen,
        openFeedbackModel,
        reportErrorFn,
        closeFeedBackModel
    };
}